import type { MonthGroup as MonthGroupData } from '../data/types'
import { EventListCard } from './EventListCard'
import { EventRow } from './EventRow'
import { EventFlyerCard } from './EventFlyerCard'
import cardStyles from './EventCard.module.css'
import styles from './MonthGroup.module.css'

/** One month section - "October 2026 · 5 events" header plus that month's events, rendered as
 *  whichever shape the current breakpoint/view calls for (mobile list card, desktop list row, or
 *  desktop flyers-view card). */
export function MonthGroup({
  month,
  isMobile,
  view,
  canSignUp,
}: {
  month: MonthGroupData
  isMobile: boolean
  view: 'list' | 'flyers'
  canSignUp: boolean
}) {
  return (
    <section className={styles.section}>
      <div className={cardStyles.monthHeader}>
        <h2 className={cardStyles.monthName}>{month.name}</h2>
        <span className={cardStyles.monthCount}>{month.count} events</span>
      </div>

      {isMobile ? (
        <div className={styles.mobileList}>
          {month.events.map((e) => (
            <EventListCard key={e.id} event={e} canSignUp={canSignUp} />
          ))}
        </div>
      ) : view === 'flyers' ? (
        <div className={styles.flyerGrid}>
          {month.events.map((e) => (
            <EventFlyerCard key={e.id} event={e} canSignUp={canSignUp} />
          ))}
        </div>
      ) : (
        <div className={styles.desktopListPanel}>
          {month.events.map((e) => (
            <EventRow key={e.id} event={e} canSignUp={canSignUp} />
          ))}
        </div>
      )}
    </section>
  )
}
